import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { Grid } from '@xsolla/ui-core';

import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { HumanIcon, StorageIcon, SupplementaryIcon, ToggleBox, UserAttributesIcon } from '../../ui';
import NavigationSettingsLink from '../NavigationSettingsLink';

const DataBaseSettings = ({ match }: RouteComponentProps): JSX.Element => {
  const { userAttributesPath, userDataStoragePath, usersPath, userSupplementaryInfoPath } =
    usePaths();
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();

  return (
    <>
      <ToggleBox
        title={intl.messages['navigation.settings.user-db.label']}
        openByDefault
        dataTestId="navigation-block-database">
        <Grid cols={2} gap={24}>
          <NavigationSettingsLink
            icon={<HumanIcon height={24} width={24} />}
            titleInfo={{
              label: intl.messages['navigation.settings.user-db.users.title'],
              path: usersPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.user-db.users.subtitle']}
          />
          <NavigationSettingsLink
            icon={<StorageIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.user-db.storage.title'],
              path: userDataStoragePath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.user-db.storage.subtitle']}
          />
          <NavigationSettingsLink
            icon={<SupplementaryIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.user-db.user-info.title'],
              path: userSupplementaryInfoPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.user-db.user-info.subtitle']}
          />
          <NavigationSettingsLink
            dataTestId="link-navigation-user-attributes-schema"
            icon={<UserAttributesIcon />}
            titleInfo={{
              label: intl.messages['navigation.settings.user-db.user-attributes.title'],
              path: userAttributesPath(projectId)
            }}
            subtitle={intl.messages['navigation.settings.user-db.user-attributes.subtitle']}
          />
        </Grid>
      </ToggleBox>
    </>
  );
};

export default withRouter(DataBaseSettings);
